export enum Language {
    en = "En",
    ar = "Ar",
    tr = "Tr"
}

